module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "function-button",
    on: {
      "click": function($event) {
        _vm.$emit('onClick')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.count))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41f3a765"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FunctionButton.vue
// module id = 54
// module chunks = 0